import { render, staticRenderFns } from "./ButtonCollapse.vue?vue&type=template&id=53868b6d&scoped=true&"
import script from "./ButtonCollapse.vue?vue&type=script&lang=js&"
export * from "./ButtonCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCollapse.vue?vue&type=style&index=0&id=53868b6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53868b6d",
  null
  
)

export default component.exports